import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
// Models
import { Post } from "./../../models/post";
// External
import { AngularFireDatabase } from "angularfire2/database";
import * as lodash from "lodash";
import { Observable } from "rxjs/Observable";
import { ApiService } from "app/services/api";

@Component({
  templateUrl: "./post.detail.component.html",
})
export class PostDetailComponent implements OnInit {
  public imageLoader: boolean = true;
  public post: any;
  public shared: Post;
  public mentioned: Array<any>;
  private postId: string;
  private author: string;
  public commentList: Array<any> = [];
  public likeList: Array<any> = [];

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private location: Location,
    private fireDatabase: AngularFireDatabase
  ) {}

  ngOnInit() {
    this.author = this.route.snapshot.paramMap.get("author");
    this.postId = this.route.snapshot.paramMap.get("id");
    if (this.author && this.postId) {
      this.initData();
    }
  }

  public initData() {
    this.fireDatabase
      .object(`/users-posts/${this.author}/${this.postId}`)
      .subscribe(async (result) => {
        this.post = result;
        if (this.post.mentioned) {
          this.mentioned = [];
          lodash.forEach(this.post.mentioned, (mention) => {
            this.mentioned.push(mention.username);
          });
        }
        let uid = this.post.userId ? this.post.userId : this.post.uid;
        this.post.author = await this.apiService.object("users/" + this.author);
        if (this.post.shared) {
          this.fireDatabase
            .object(
              `/users-posts/${this.post.shared.uid}/${this.post.shared.pid}`
            )
            .subscribe((shared) => {
              this.shared = shared;
            });
        }
      });
    this.likeList = [];
    this.fireDatabase
      .object(`/posts/${this.postId}/likes`)
      .subscribe((result) => {
        lodash.forEach(result, (item, key) => {
          if (item) {
            this.fireDatabase.object("users/" + key).subscribe((user) => {
              this.likeList.push(user);
            });
          }
        });
      });
    this.fireDatabase
      .object(`/posts/${this.postId}/comments`)
      .subscribe((result) => {
        lodash.forEach(result, (item, key) => {
          if (item) {
            this.fireDatabase
              .object("users/" + item.author)
              .subscribe((user) => {
                item.author = user;
                this.commentList.push(item);
              });
          }
        });
      });
    setTimeout(() => {
      this.imageLoader = false;
    }, 1500);
  }

  public back() {
    this.location.back();
  }
}
